module.exports = __webpack_public_path__ + "static/media/table_of_levels.cd700a8e.svg";